import React, { useState, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Space, Row, Spinner } from "@masterteam/mt-design-react";

import ProgramCard from "./ProgramCard";
import DeleteModal from "../DeleteModal";
import CreateProgramForm from "../CreateProgramForm";

import api from "../../providers/api";
import { addToast } from "../../helpers";

import "./style.scss";

const initialModalState = {
  isOpen: false,
  data: null,
};

const Programs = () => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const [programs, setPrograms] = useState([]);
  const [programFormModel, setProgramFormModel] = useState(initialModalState);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(initialModalState);

  const handleDelete = (id) => {
    setDeleteLoading(true);
    api.programs
      .delete(id)
      .then((res) => {
        const { StatusCode, StatusMessage } = res;
        if (StatusCode === "Success") {
          setDeleteModal(initialModalState);
          addToast.success("toast.successDelete");
          getPrograms();
        } else if (StatusCode === "fail") {
          addToast.error(StatusMessage, {
            toastId: "get-users-error",
          });
        }
      })
      .catch((error) => {
        addToast.error(error.message, {
          toastId: "get-users-error",
        });
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  };

  const getPrograms = async () => {
    setLoading(true);
    try {
      const res = await api.programs.getAll();
      setPrograms(res.Data);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPrograms();
  }, []);

  return (
    <Space direction="vertical" size="large" className="programs-container">
      <Row className="title-wrapper">
        <FormattedMessage id={`common.programs`} />
      </Row>
      {loading ? (
        <Row justify="center">
          <Spinner size="large" />
        </Row>
      ) : (
        <div className="cards-wrapper">
          {programs.map((item) => (
            <ProgramCard
              setDeleteModal={setDeleteModal}
              data={item}
              key={item?.ID}
              setProgramFormModel={setProgramFormModel}
            />
          ))}
        </div>
      )}

      {programFormModel.isOpen && (
        <CreateProgramForm
          data={programFormModel.data}
          closeModal={() => setProgramFormModel(initialModalState)}
          getPrograms={getPrograms}
        />
      )}

      {deleteModal.isOpen ? (
        <DeleteModal
          isOpen={deleteModal.isOpen}
          title={intl.formatMessage({ id: "common.program" })}
          closeModal={() => setDeleteModal(initialModalState)}
          handleDelete={() => handleDelete(deleteModal.data)}
          ButtonStatus={deleteLoading}
        />
      ) : null}
    </Space>
  );
};

export default Programs;
